const fdaCitationData = [
    {
        "partNumber": 170,
        "sections": [
            {
                "sectionName": "39",
                "description": "Threshold of regulation for substances used in food-contact articles."
            }
        ]
    },
    {
        "partNumber": 172,
        "sections": [
            {
                "sectionName": "N/A",
                "description": "FOOD ADDITIVES PERMITTED FOR DIRECT ADDITION TO FOOD FOR HUMAN CONSUMPTION"
            },
            {
                "sectionName": "878",
                "description": "White mineral oil."
            },
            {
                "sectionName": "880",
                "description": "Petrolatum."
            }
        ]
    },
    {
        "partNumber": 173,
        "sections": [
            {
                "sectionName": "N/A",
                "description": "SECONDARY DIRECT FOOD ADDITIVES PERMITTED IN FOOD FOR HUMAN CONSUMPTION"
            }
        ]
    },
    {
        "partNumber": 174,
        "sections": [
            {
                "sectionName": "N/A",
                "description": "INDIRECT FOOD ADDITIVES: GENERAL"
            },
            {
                "sectionName": "5",
                "description": "General provisions applicable to indirect food additives."
            },
            {
                "sectionName": "6",
                "description": "Threshold of regulation for substances used in food-contact articles."
            }
        ]
    },
    {
        "partNumber": 175,
        "sections": [
            {
                "sectionName": "105",
                "description": "Adhesives."
            },
            {
                "sectionName": "125",
                "description": "Pressure-sensitive adhesives."
            },
            {
                "sectionName": "210",
                "description": "Acrylate ester copolymer coating."
            },
            {
                "sectionName": "230",
                "description": "Hot-melt strippable food coatings."
            },
            {
                "sectionName": "250",
                "description": "Paraffin (synthetic)."
            },
            {
                "sectionName": "260",
                "description": "Partial phosphoric acid esters of polyester resins."
            },
            {
                "sectionName": "270",
                "description": "Poly(vinyl fluoride) resins."
            },
            {
                "sectionName": "300",
                "description": "Resinous and polymeric coatings."
            },
            {
                "sectionName": "320",
                "description": "Resinous and polymeric coatings for polyolefin films."
            },
            {
                "sectionName": "350",
                "description": "Vinyl acetate\/crotonic acid copolymer."
            },
            {
                "sectionName": "360",
                "description": "Vinylidene chloride copolymer coatings for nylon film."
            },
            {
                "sectionName": "365",
                "description": "Vinylidene chloride copolymer coatings for polycarbonate film."
            },
            {
                "sectionName": "380",
                "description": "Xylene-formaldehyde resins condensed with 4,4'-isopropylidenediphenol-epichlorohydrin epoxy resins."
            },
            {
                "sectionName": "390",
                "description": "Zinc-silicon dioxide matrix coatings."
            }
        ]
    },
    {
        "partNumber": 176,
        "sections": [
            {
                "sectionName": "110",
                "description": "Acrylamide-acrylic acid resins."
            },
            {
                "sectionName": "120",
                "description": "Alkyl ketene dimers."
            },
            {
                "sectionName": "130",
                "description": "Anti-offset substances."
            },
            {
                "sectionName": "150",
                "description": "Chelating agents used in the manufacture of paper and paperboard."
            },
            {
                "sectionName": "160",
                "description": "Chromium (Cr III) complex of�N-ethyl-N-heptadecylfluoro-octane sulfonyl glycine."
            },
            {
                "sectionName": "170",
                "description": "Components of paper and paperboard in contact with aqueous and fatty foods."
            },
            {
                "sectionName": "180",
                "description": "Components of paper and paperboard in contact with dry food."
            },
            {
                "sectionName": "200",
                "description": "Defoaming agents used in coatings."
            },
            {
                "sectionName": "210",
                "description": "Defoaming agents used in the manufacture of paper and paperboard."
            },
            {
                "sectionName": "230",
                "description": "3,5-Dimethyl-1,3,5,2H-tetrahydrothiadiazine-2-thione."
            },
            {
                "sectionName": "250",
                "description": "Poly-1,4,7,10,13-pentaaza-15-hydroxyhexadecane."
            },
            {
                "sectionName": "260",
                "description": "Pulp from reclaimed fiber."
            },
            {
                "sectionName": "300",
                "description": "Slimicides."
            },
            {
                "sectionName": "320",
                "description": "Sodium nitrate-urea complex."
            },
            {
                "sectionName": "350",
                "description": "Tamarind seed kernel powder."
            }
        ]
    },
    {
        "partNumber": 177,
        "sections": [
            {
                "sectionName": "1010",
                "description": "Acrylic and modified acrylic plastics, semirigid and rigid."
            },
            {
                "sectionName": "1020",
                "description": "Acrylonitrile\/butadiene\/styrene co-polymer."
            },
            {
                "sectionName": "1030",
                "description": "Acrylonitrile\/butadiene\/styrene\/methyl methacrylate copolymer."
            },
            {
                "sectionName": "1040",
                "description": "Acrylonitrile\/styrene copoly-mer."
            },
            {
                "sectionName": "1050",
                "description": "Acrylonitrile\/styrene copoly-mer modified with butadiene\/styrene elastomer."
            },
            {
                "sectionName": "1060",
                "description": "n-Alkylglutarimide\/acrylic copolymers."
            },
            {
                "sectionName": "1200",
                "description": "Cellophane."
            },
            {
                "sectionName": "1210",
                "description": "Closures with sealing gaskets for food containers."
            },
            {
                "sectionName": "1211",
                "description": "Cross-linked polyacrylate copolymers."
            },
            {
                "sectionName": "1240",
                "description": "1,4-Cyclohexylene dimethylene terephthalate and 1,4-cyclohexylene dimethylene isophthalate copolymer."
            },
            {
                "sectionName": "1310",
                "description": "Ethylene-acrylic acid copolymers."
            },
            {
                "sectionName": "1312",
                "description": "Ethylene-carbon monoxide copolymers."
            },
            {
                "sectionName": "1315",
                "description": "Ethylene-1, 4-cyclohexylene dimethylene terephthalate copolymers."
            },
            {
                "sectionName": "1320",
                "description": "Ethylene-ethyl acrylate copolymers."
            },
            {
                "sectionName": "1330",
                "description": "Ionomeric resins."
            },
            {
                "sectionName": "1340",
                "description": "Ethylene-methyl acrylate copolymer resins."
            },
            {
                "sectionName": "1345",
                "description": "Ethylene\/1,3-phenylene oxyethylene isophthalate\/ terephthalate copolymer."
            },
            {
                "sectionName": "1350",
                "description": "Ethylene-vinyl acetate copolymers."
            },
            {
                "sectionName": "1360",
                "description": "Ethylene-vinyl acetate-vinyl alcohol copolymers."
            },
            {
                "sectionName": "1380",
                "description": "Fluorocarbon resins."
            },
            {
                "sectionName": "1390",
                "description": "Laminate structures for use at temperatures of 250 �F and above."
            },
            {
                "sectionName": "1395",
                "description": "Laminate structures for use at temperatures between 120 �F and 250 �F."
            },
            {
                "sectionName": "1400",
                "description": "Hydroxyethyl cellulose film, water-insoluble."
            },
            {
                "sectionName": "1420",
                "description": "Isobutylene polymers."
            },
            {
                "sectionName": "1430",
                "description": "Isobutylene-butene copolymers."
            },
            {
                "sectionName": "1440",
                "description": "4,4'-Isopropylidenediphenol-epichlorohydrin resins minimum molecular weight 10,000."
            },
            {
                "sectionName": "1460",
                "description": "Melamine-formaldehyde resins in molded articles."
            },
            {
                "sectionName": "1480",
                "description": "Nitrile rubber modified acrylonitrile-methyl acrylate copolymers."
            },
            {
                "sectionName": "1500",
                "description": "Nylon resins."
            },
            {
                "sectionName": "1520",
                "description": "Olefin polymers.",
                "subSections": [
                    {
                        "subSectionName": "1.1a",
                        "description": "Olefin polymers. Polypropylene"
                    },
                    {
                        "subSectionName": "1.1b",
                        "description": "Olefin polymers. Polypropylene homopolymer"
                    },
                    {
                        "subSectionName": "1.2",
                        "description": "Olefin polymers. Polypropylene noncrystalline"
                    },
                    {
                        "subSectionName": "1.3",
                        "description": "Olefin polymers. Polypropylene noncrystalline"
                    },
                    {
                        "subSectionName": "2.1",
                        "description": "Olefin polymers. Polyethylene (non-cooking)"
                    },
                    {
                        "subSectionName": "2.2",
                        "description": "Olefin polymers. Polyethylene (cooking)"
                    },
                    {
                        "subSectionName": "2.3",
                        "description": "Olefin polymers. Polyethylene"
                    },
                    {
                        "subSectionName": "2.4",
                        "description": "Olefin polymers."
                    },
                    {
                        "subSectionName": "3.1a",
                        "description": "Olefin polymers. Olefin copolymer (non-cooking)"
                    },
                    {
                        "subSectionName": "3.1b",
                        "description": "Olefin polymers. Olefin copolymer (non-cooking)"
                    },
                    {
                        "subSectionName": "3.1c",
                        "description": "Olefin polymers. Olefin copolymer (non-cooking)"
                    },
                    {
                        "subSectionName": "3.2a",
                        "description": "Olefin polymers. Olefin copolymer (cooking)"
                    },
                    {
                        "subSectionName": "3.2b",
                        "description": "Olefin polymers. Olefin copolymer (cooking)"
                    },
                    {
                        "subSectionName": "3.2c",
                        "description": "Olefin polymers. Olefin copolymer (cooking)"
                    },
                    {
                        "subSectionName": "3.3a",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.3b",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.4",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.5",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.6",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.7",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.8",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "3.9",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "4",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "5",
                        "description": "Olefin polymers - Subsection"
                    },
                    {
                        "subSectionName": "6",
                        "description": "Olefin polymers - Subsection"
                    }
                ]
            },
            {
                "sectionName": "1550",
                "description": "Perfluorocarbon resins."
            },
            {
                "sectionName": "1555",
                "description": "Polyarylate resins."
            },
            {
                "sectionName": "1556",
                "description": "Polyaryletherketone resins."
            },
            {
                "sectionName": "1560",
                "description": "Polyarylsulfone resins."
            },
            {
                "sectionName": "1570",
                "description": "Poly-1-butene resins and butene\/ethylene copolymers."
            },
            {
                "sectionName": "1580",
                "description": "Polycarbonate resins."
            },
            {
                "sectionName": "1585",
                "description": "Polyestercarbonate resins."
            },
            {
                "sectionName": "1590",
                "description": "Polyester elastomers."
            },
            {
                "sectionName": "1595",
                "description": "Polyetherimide resin."
            },
            {
                "sectionName": "1600",
                "description": "Polyethylene resins, carboxyl modified."
            },
            {
                "sectionName": "1610",
                "description": "Polyethylene, chlorinated."
            },
            {
                "sectionName": "1615",
                "description": "Polyethylene, fluorinated."
            },
            {
                "sectionName": "1620",
                "description": "Polyethylene, oxidized."
            },
            {
                "sectionName": "1630",
                "description": "Polyethylene phthalate polymers."
            },
            {
                "sectionName": "1632",
                "description": "Poly(phenyleneterephthalamide) resins."
            },
            {
                "sectionName": "1635",
                "description": "Poly(p-methylstyrene) and rubber-modified poly(p-methylstyrene)."
            },
            {
                "sectionName": "1637",
                "description": "Poly(oxy-1,2-ethanediyloxycarbonyl-2,6-naphthalenediylcarbonyl) resins."
            },
            {
                "sectionName": "1640",
                "description": "Polystyrene and rubber-modified polystyrene."
            },
            {
                "sectionName": "1650",
                "description": "Polysulfide polymer-polyepoxy resins."
            },
            {
                "sectionName": "1655",
                "description": "Polysulfone resins."
            },
            {
                "sectionName": "1660",
                "description": "Poly (tetramethylene terephthalate)."
            },
            {
                "sectionName": "1670",
                "description": "Polyvinyl alcohol film."
            },
            {
                "sectionName": "1680",
                "description": "Polyurethane resins."
            },
            {
                "sectionName": "1810",
                "description": "Styrene block polymers."
            },
            {
                "sectionName": "1820",
                "description": "Styrene-maleic anhydride copolymers."
            },
            {
                "sectionName": "1830",
                "description": "Styrene-methyl methacrylate copolymers."
            },
            {
                "sectionName": "1850",
                "description": "Textryls."
            },
            {
                "sectionName": "1900",
                "description": "Urea-formaldehyde resins in molded articles."
            },
            {
                "sectionName": "1950",
                "description": "Vinyl chloride-ethylene copolymers."
            },
            {
                "sectionName": "1960",
                "description": "Vinyl chloride-hexene-1 copolymers."
            },
            {
                "sectionName": "1970",
                "description": "Vinyl chloride-lauryl vinyl ether copolymers."
            },
            {
                "sectionName": "1980",
                "description": "Vinyl chloride-propylene copolymers."
            },
            {
                "sectionName": "1990",
                "description": "Vinylidene chloride\/methyl acrylate copolymers."
            },
            {
                "sectionName": "2000",
                "description": "Vinylidene chloride\/methyl acrylate\/methyl methacrylate polymers."
            },
            {
                "sectionName": "2210",
                "description": "Ethylene polymer, chlorosulfonated."
            },
            {
                "sectionName": "2250",
                "description": "Filters, microporous polymeric."
            },
            {
                "sectionName": "2260",
                "description": "Filters, resin-bonded."
            },
            {
                "sectionName": "2280",
                "description": "4,4'-Isopropylidenediphenolepichlorohydrin thermosetting epoxy resins."
            },
            {
                "sectionName": "2355",
                "description": "Mineral reinforced nylon resins."
            },
            {
                "sectionName": "2400",
                "description": "Perfluorocarbon cured elastomers."
            },
            {
                "sectionName": "2410",
                "description": "Phenolic resins in molded articles."
            },
            {
                "sectionName": "2415",
                "description": "Poly(aryletherketone) resins."
            },
            {
                "sectionName": "2420",
                "description": "Polyester resins, cross-linked."
            },
            {
                "sectionName": "2430",
                "description": "Polyether resins, chlorinated."
            },
            {
                "sectionName": "2440",
                "description": "Polyethersulfone resins."
            },
            {
                "sectionName": "2450",
                "description": "Polyamide-imide resins."
            },
            {
                "sectionName": "2460",
                "description": "Poly(2,6-dimethyl-1,4-phenylene) oxide resins."
            },
            {
                "sectionName": "2465",
                "description": "Polymethylmethacrylate\/poly(trimethoxysilylpropyl)methacrylate copolymers."
            },
            {
                "sectionName": "2470",
                "description": "Polyoxymethylene copolymer."
            },
            {
                "sectionName": "2480",
                "description": "Polyoxymethylene homopolymer."
            },
            {
                "sectionName": "2490",
                "description": "Polyphenylene sulfide resins."
            },
            {
                "sectionName": "2500",
                "description": "Polyphenylene sulfone resins."
            },
            {
                "sectionName": "2510",
                "description": "Polyvinylidene fluoride resins."
            },
            {
                "sectionName": "2550",
                "description": "Reverse osmosis membranes."
            },
            {
                "sectionName": "2600",
                "description": "Rubber articles intended for repeated use."
            },
            {
                "sectionName": "2710",
                "description": "Styrene-divinylbenzene resins, cross-linked."
            },
            {
                "sectionName": "2800",
                "description": "Textiles and textile fibers."
            },
            {
                "sectionName": "2910",
                "description": "Ultra-filtration membranes."
            }
        ]
    },
    {
        "partNumber": 178,
        "sections": [
            {
                "sectionName": "1005",
                "description": "Hydrogen peroxide solution."
            },
            {
                "sectionName": "1010",
                "description": "Sanitizing solutions."
            },
            {
                "sectionName": "2010",
                "description": "Antioxidants and\/or stabilizers for polymers."
            },
            {
                "sectionName": "2550",
                "description": "4-Hydroxymethyl-2,6-di-tert-butylphenol."
            },
            {
                "sectionName": "2650",
                "description": "Organotin stabilizers in vinyl chloride plastics."
            },
            {
                "sectionName": "3010",
                "description": "Adjuvant substances used in the manufacture of foamed plastics."
            },
            {
                "sectionName": "3120",
                "description": "Animal glue."
            },
            {
                "sectionName": "3125",
                "description": "Anticorrosive agents."
            },
            {
                "sectionName": "3130",
                "description": "Antistatic and\/or antifogging agents in food-packaging materials."
            },
            {
                "sectionName": "3280",
                "description": "Castor oil, hydrogenated."
            },
            {
                "sectionName": "3290",
                "description": "Chromic chloride complexes."
            },
            {
                "sectionName": "3295",
                "description": "Clarifying agents for polymers."
            },
            {
                "sectionName": "3297",
                "description": "Colorants for polymers."
            },
            {
                "sectionName": "3300",
                "description": "Corrosion inhibitors used for steel or tinplate."
            },
            {
                "sectionName": "3400",
                "description": "Emulsifiers and\/or surface-active agents."
            },
            {
                "sectionName": "3450",
                "description": "Esters of stearic and palmitic acids."
            },
            {
                "sectionName": "3480",
                "description": "Fatty alcohols, synthetic."
            },
            {
                "sectionName": "3500",
                "description": "Glycerin, synthetic."
            },
            {
                "sectionName": "3505",
                "description": "Glyceryl tri-(12-acetoxystearate)."
            },
            {
                "sectionName": "3520",
                "description": "Industrial starch-modified."
            },
            {
                "sectionName": "3530",
                "description": "Isoparaffinic petroleum hydrocarbons, synthetic."
            },
            {
                "sectionName": "3570",
                "description": "Lubricants with incidental food contact."
            },
            {
                "sectionName": "3600",
                "description": "Methyl glucoside-coconut oil ester."
            },
            {
                "sectionName": "3610",
                "description": "a-Methylstyrene-vinyltoluene resins, hydrogenated."
            },
            {
                "sectionName": "3620",
                "description": "Mineral oil."
            },
            {
                "sectionName": "3650",
                "description": "Odorless light petroleum hydrocarbons."
            },
            {
                "sectionName": "3690",
                "description": "Pentaerythritol adipate-stearate."
            },
            {
                "sectionName": "3700",
                "description": "Petrolatum."
            },
            {
                "sectionName": "3710",
                "description": "Petroleum wax."
            },
            {
                "sectionName": "3720",
                "description": "Petroleum wax, synthetic."
            },
            {
                "sectionName": "3725",
                "description": "Pigment dispersants."
            },
            {
                "sectionName": "3730",
                "description": "Piperonyl butoxide and pyrethrins as components of bags."
            },
            {
                "sectionName": "3740",
                "description": "Plasticizers in polymeric substances."
            },
            {
                "sectionName": "3750",
                "description": "Polyethylene glycol (mean molecular weight 200-9,500)."
            },
            {
                "sectionName": "3760",
                "description": "Polyethylene glycol (400) monolaurate."
            },
            {
                "sectionName": "3770",
                "description": "Polyhydric alcohol esters of oxidatively refined (Gersthofen process) montan wax acids."
            },
            {
                "sectionName": "3780",
                "description": "Polyhydric alcohol esters of long chain monobasic acids."
            },
            {
                "sectionName": "3790",
                "description": "Polymer modifiers in semirigid and rigid vinyl chloride plastics."
            },
            {
                "sectionName": "3800",
                "description": "Preservatives for wood."
            },
            {
                "sectionName": "3850",
                "description": "Reinforced wax."
            },
            {
                "sectionName": "3860",
                "description": "Release agents."
            },
            {
                "sectionName": "3870",
                "description": "Rosins and rosin derivatives."
            },
            {
                "sectionName": "3900",
                "description": "Sodium pentachlorophenate."
            },
            {
                "sectionName": "3910",
                "description": "Surface lubricants used in the manufacture of metallic articles."
            },
            {
                "sectionName": "3930",
                "description": "Terpene resins."
            },
            {
                "sectionName": "3940",
                "description": "Tetraethylene glycol di-(2-ethylhexoate)."
            },
            {
                "sectionName": "3950",
                "description": "Tetrahydrofuran."
            }
        ]
    },
    {
        "partNumber": 179,
        "sections": [
            {
                "sectionName": "21",
                "description": "Sources of radiation used for inspection of food, for inspection of packaged food, and for controlling food processing."
            },
            {
                "sectionName": "25",
                "description": "General provisions for food irradiation."
            },
            {
                "sectionName": "26",
                "description": "Ionizing radiation for the treatment of food."
            },
            {
                "sectionName": "30",
                "description": "Radiofrequency radiation for the heating of food, including microwave frequencies."
            },
            {
                "sectionName": "39",
                "description": "Ultraviolet radiation for the processing and treatment of food."
            },
            {
                "sectionName": "41",
                "description": "Pulsed light for the treatment of food."
            },
            {
                "sectionName": "43",
                "description": "Carbon dioxide laser for etching food."
            },
            {
                "sectionName": "45",
                "description": "Packaging materials for use during the irradiation of prepackaged foods."
            }
        ]
    },
    {
        "partNumber": 180,
        "sections": [
            {
                "sectionName": "1",
                "description": "General."
            },
            {
                "sectionName": "22",
                "description": "Acrylonitrile copolymers."
            },
            {
                "sectionName": "25",
                "description": "Mannitol."
            },
            {
                "sectionName": "30",
                "description": "Brominated vegetable oil."
            },
            {
                "sectionName": "37",
                "description": "Saccharin, ammonium saccharin, calcium saccharin, and sodium saccharin."
            }
        ]
    },
    {
        "partNumber": 181,
        "sections": [
            {
                "sectionName": "1",
                "description": "General."
            },
            {
                "sectionName": "5",
                "description": "Prior sanctions."
            },
            {
                "sectionName": "22",
                "description": "Certain substances employed in the manufacture of food-packaging materials."
            },
            {
                "sectionName": "23",
                "description": "Antimycotics."
            },
            {
                "sectionName": "24",
                "description": "Antioxidants."
            },
            {
                "sectionName": "25",
                "description": "Driers."
            },
            {
                "sectionName": "26",
                "description": "Drying oils as components of finished resins."
            },
            {
                "sectionName": "27",
                "description": "Plasticizers."
            },
            {
                "sectionName": "28",
                "description": "Release agents."
            },
            {
                "sectionName": "29",
                "description": "Stabilizers."
            },
            {
                "sectionName": "30",
                "description": "Substances used in the manufacture of paper and paperboard products used in food packaging."
            },
            {
                "sectionName": "32",
                "description": "Acrylonitrile copolymers and resins."
            },
            {
                "sectionName": "33",
                "description": "Sodium nitrate and potassium nitrate."
            },
            {
                "sectionName": "34",
                "description": "Sodium nitrite and potassium nitrite."
            }
        ]
    },
    {
        "partNumber": 182,
        "sections": [
            {
                "sectionName": "1",
                "description": "Substances that are generally recognized as safe."
            },
            {
                "sectionName": "10",
                "description": "Spices and other natural seasonings and flavorings."
            },
            {
                "sectionName": "20",
                "description": "Essential oils, oleoresins (solvent-free), and natural extractives (including distillates)."
            },
            {
                "sectionName": "40",
                "description": "Natural extractives (solvent-free) used in conjunction with spices, seasonings, and flavorings."
            },
            {
                "sectionName": "50",
                "description": "Certain other spices, seasonings, essential oils, oleoresins, and natural extracts."
            },
            {
                "sectionName": "60",
                "description": "Synthetic flavoring substances and adjuvants."
            },
            {
                "sectionName": "70",
                "description": "Substances migrating from cotton and cotton fabrics used in dry food packaging."
            },
            {
                "sectionName": "90",
                "description": "Substances migrating to food from paper and paperboard products."
            },
            {
                "sectionName": "99",
                "description": "Adjuvants for pesticide chemicals."
            },
            {
                "sectionName": "1045",
                "description": "Glutamic acid."
            },
            {
                "sectionName": "1047",
                "description": "Glutamic acid hydrochloride."
            },
            {
                "sectionName": "1057",
                "description": "Hydrochloric acid."
            },
            {
                "sectionName": "1073",
                "description": "Phosphoric acid."
            },
            {
                "sectionName": "1087",
                "description": "Sodium acid pyrophosphate."
            },
            {
                "sectionName": "1125",
                "description": "Aluminum sulfate."
            },
            {
                "sectionName": "1127",
                "description": "Aluminum ammonium sulfate."
            },
            {
                "sectionName": "1129",
                "description": "Aluminum potassium sulfate."
            },
            {
                "sectionName": "1131",
                "description": "Aluminum sodium sulfate."
            },
            {
                "sectionName": "1180",
                "description": "Caffeine."
            },
            {
                "sectionName": "1217",
                "description": "Calcium phosphate."
            },
            {
                "sectionName": "1235",
                "description": "Caramel."
            },
            {
                "sectionName": "1320",
                "description": "Glycerin."
            },
            {
                "sectionName": "1480",
                "description": "Methylcellulose."
            },
            {
                "sectionName": "1500",
                "description": "Monoammonium glutamate."
            },
            {
                "sectionName": "1516",
                "description": "Monopotassium glutamate."
            },
            {
                "sectionName": "1711",
                "description": "Silica aerogel."
            },
            {
                "sectionName": "1745",
                "description": "Sodium carboxymethylcellulose."
            },
            {
                "sectionName": "1748",
                "description": "Sodium caseinate."
            },
            {
                "sectionName": "1778",
                "description": "Sodium phosphate."
            },
            {
                "sectionName": "1781",
                "description": "Sodium aluminum phosphate."
            },
            {
                "sectionName": "1810",
                "description": "Sodium tripolyphosphate."
            },
            {
                "sectionName": "2122",
                "description": "Aluminum calcium silicate."
            },
            {
                "sectionName": "2227",
                "description": "Calcium silicate."
            },
            {
                "sectionName": "2437",
                "description": "Magnesium silicate."
            },
            {
                "sectionName": "2727",
                "description": "Sodium aluminosilicate."
            },
            {
                "sectionName": "2729",
                "description": "Sodium calcium aluminosilicate, hydrated."
            },
            {
                "sectionName": "2906",
                "description": "Tricalcium silicate."
            },
            {
                "sectionName": "3013",
                "description": "Ascorbic acid."
            },
            {
                "sectionName": "3041",
                "description": "Erythorbic acid."
            },
            {
                "sectionName": "3089",
                "description": "Sorbic acid."
            },
            {
                "sectionName": "3109",
                "description": "Thiodipropionic acid."
            },
            {
                "sectionName": "3149",
                "description": "Ascorbyl palmitate."
            },
            {
                "sectionName": "3169",
                "description": "Butylated hydroxyanisole."
            },
            {
                "sectionName": "3173",
                "description": "Butylated hydroxytoluene."
            },
            {
                "sectionName": "3189",
                "description": "Calcium ascorbate."
            },
            {
                "sectionName": "3225",
                "description": "Calcium sorbate."
            },
            {
                "sectionName": "3280",
                "description": "Dilauryl thiodipropionate."
            },
            {
                "sectionName": "3616",
                "description": "Potassium bisulfite."
            },
            {
                "sectionName": "3637",
                "description": "Potassium metabisulfite."
            },
            {
                "sectionName": "3640",
                "description": "Potassium sorbate."
            },
            {
                "sectionName": "3731",
                "description": "Sodium ascorbate."
            },
            {
                "sectionName": "3739",
                "description": "Sodium bisulfite."
            },
            {
                "sectionName": "3766",
                "description": "Sodium metabisulfite."
            },
            {
                "sectionName": "3795",
                "description": "Sodium sorbate."
            },
            {
                "sectionName": "3798",
                "description": "Sodium sulfite."
            },
            {
                "sectionName": "3862",
                "description": "Sulfur dioxide."
            },
            {
                "sectionName": "3890",
                "description": "Tocopherols."
            },
            {
                "sectionName": "6085",
                "description": "Sodium acid phosphate."
            },
            {
                "sectionName": "6197",
                "description": "Calcium diacetate."
            },
            {
                "sectionName": "6203",
                "description": "Calcium hexametaphosphate."
            },
            {
                "sectionName": "6215",
                "description": "Monobasic calcium phosphate."
            },
            {
                "sectionName": "6285",
                "description": "Dipotassium phosphate."
            },
            {
                "sectionName": "6290",
                "description": "Disodium phosphate."
            },
            {
                "sectionName": "6757",
                "description": "Sodium gluconate."
            },
            {
                "sectionName": "6760",
                "description": "Sodium hexametaphosphate."
            },
            {
                "sectionName": "6769",
                "description": "Sodium metaphosphate."
            },
            {
                "sectionName": "6778",
                "description": "Sodium phosphate."
            },
            {
                "sectionName": "6787",
                "description": "Sodium pyrophosphate."
            },
            {
                "sectionName": "6789",
                "description": "Tetra sodium pyrophosphate."
            },
            {
                "sectionName": "6810",
                "description": "Sodium tripolyphosphate."
            },
            {
                "sectionName": "7255",
                "description": "Chondrus extract."
            },
            {
                "sectionName": "8013",
                "description": "Ascorbic acid."
            },
            {
                "sectionName": "8159",
                "description": "Biotin."
            },
            {
                "sectionName": "8217",
                "description": "Calcium phosphate."
            },
            {
                "sectionName": "8223",
                "description": "Calcium pyrophosphate."
            },
            {
                "sectionName": "8250",
                "description": "Choline bitartrate."
            },
            {
                "sectionName": "8252",
                "description": "Choline chloride."
            },
            {
                "sectionName": "8778",
                "description": "Sodium phosphate."
            },
            {
                "sectionName": "8890",
                "description": "Tocopherols."
            },
            {
                "sectionName": "8892",
                "description": "a-Tocopherol acetate."
            },
            {
                "sectionName": "8985",
                "description": "Zinc chloride."
            },
            {
                "sectionName": "8988",
                "description": "Zinc gluconate."
            },
            {
                "sectionName": "8991",
                "description": "Zinc oxide."
            },
            {
                "sectionName": "8994",
                "description": "Zinc stearate."
            },
            {
                "sectionName": "8997",
                "description": "Zinc sulfate."
            }
        ]
    },
    {
        "partNumber": 184,
        "sections": [
            {
                "sectionName": "1",
                "description": "Substances added directly to human food affirmed as generally recognized as safe (GRAS). Please list all GRAS substances along with any FDA GRAS letters or company justifications"
            },
            {
                "sectionName": "1005",
                "description": "Acetic acid."
            },
            {
                "sectionName": "1007",
                "description": "Aconitic acid."
            },
            {
                "sectionName": "1009",
                "description": "Adipic acid."
            },
            {
                "sectionName": "1011",
                "description": "Alginic acid."
            },
            {
                "sectionName": "1012",
                "description": "a-Amylase enzyme preparation from Bacillus stearothermophilus."
            },
            {
                "sectionName": "1021",
                "description": "Benzoic acid."
            },
            {
                "sectionName": "1024",
                "description": "Bromelain."
            },
            {
                "sectionName": "1025",
                "description": "Caprylic acid."
            },
            {
                "sectionName": "1027",
                "description": "Mixed carbohydrase and protease enzyme product."
            },
            {
                "sectionName": "1033",
                "description": "Citric acid."
            },
            {
                "sectionName": "1034",
                "description": "Catalase (bovine liver)."
            },
            {
                "sectionName": "1061",
                "description": "Lactic acid."
            },
            {
                "sectionName": "1063",
                "description": "Enzyme-modified lecithin."
            },
            {
                "sectionName": "1065",
                "description": "Linoleic acid."
            },
            {
                "sectionName": "1069",
                "description": "Malic acid."
            },
            {
                "sectionName": "1077",
                "description": "Potassium acid tartrate."
            },
            {
                "sectionName": "1081",
                "description": "Propionic acid."
            },
            {
                "sectionName": "1090",
                "description": "Stearic acid."
            },
            {
                "sectionName": "1091",
                "description": "Succinic acid."
            },
            {
                "sectionName": "1095",
                "description": "Sulfuric acid."
            },
            {
                "sectionName": "1097",
                "description": "Tannic acid."
            },
            {
                "sectionName": "1099",
                "description": "Tartaric acid."
            },
            {
                "sectionName": "1101",
                "description": "Diacetyl tartaric acid esters of mono- and diglycerides."
            },
            {
                "sectionName": "1115",
                "description": "Agar-agar."
            },
            {
                "sectionName": "1120",
                "description": "Brown algae."
            },
            {
                "sectionName": "1121",
                "description": "Red algae."
            },
            {
                "sectionName": "1133",
                "description": "Ammonium alginate."
            },
            {
                "sectionName": "1135",
                "description": "Ammonium bicarbonate."
            },
            {
                "sectionName": "1137",
                "description": "Ammonium carbonate."
            },
            {
                "sectionName": "1138",
                "description": "Ammonium chloride."
            },
            {
                "sectionName": "1139",
                "description": "Ammonium hydroxide."
            },
            {
                "sectionName": "1140",
                "description": "Ammonium citrate, dibasic."
            },
            {
                "sectionName": "1141a",
                "description": "Ammonium phosphate, monobasic."
            },
            {
                "sectionName": "1141b",
                "description": "Ammonium phosphate, dibasic."
            },
            {
                "sectionName": "1143",
                "description": "Ammonium sulfate."
            },
            {
                "sectionName": "1148",
                "description": "Bacterially-derived carbohydrase enzyme preparation."
            },
            {
                "sectionName": "1150",
                "description": "Bacterially-derived protease enzyme preparation."
            },
            {
                "sectionName": "1155",
                "description": "Bentonite."
            },
            {
                "sectionName": "1157",
                "description": "Benzoyl peroxide."
            },
            {
                "sectionName": "1165",
                "description": "n-Butane and iso-butane."
            },
            {
                "sectionName": "1185",
                "description": "Calcium acetate."
            },
            {
                "sectionName": "1187",
                "description": "Calcium alginate."
            },
            {
                "sectionName": "1191",
                "description": "Calcium carbonate."
            },
            {
                "sectionName": "1193",
                "description": "Calcium chloride."
            },
            {
                "sectionName": "1195",
                "description": "Calcium citrate."
            },
            {
                "sectionName": "1199",
                "description": "Calcium gluconate."
            },
            {
                "sectionName": "1201",
                "description": "Calcium glycerophosphate."
            },
            {
                "sectionName": "1205",
                "description": "Calcium hydroxide."
            },
            {
                "sectionName": "1206",
                "description": "Calcium iodate."
            },
            {
                "sectionName": "1207",
                "description": "Calcium lactate."
            },
            {
                "sectionName": "1210",
                "description": "Calcium oxide."
            },
            {
                "sectionName": "1212",
                "description": "Calcium pantothenate."
            },
            {
                "sectionName": "1221",
                "description": "Calcium propionate."
            },
            {
                "sectionName": "1229",
                "description": "Calcium stearate."
            },
            {
                "sectionName": "1230",
                "description": "Calcium sulfate."
            },
            {
                "sectionName": "1240",
                "description": "Carbon dioxide."
            },
            {
                "sectionName": "1245",
                "description": "Beta-carotene."
            },
            {
                "sectionName": "1250",
                "description": "Cellulase enzyme preparation derived from Trichoderma longibrachiatum."
            },
            {
                "sectionName": "1257",
                "description": "Clove and its derivatives."
            },
            {
                "sectionName": "1259",
                "description": "Cocoa butter substitute."
            },
            {
                "sectionName": "1260",
                "description": "Copper gluconate."
            },
            {
                "sectionName": "1261",
                "description": "Copper sulfate."
            },
            {
                "sectionName": "1262",
                "description": "Corn silk and corn silk extract."
            },
            {
                "sectionName": "1265",
                "description": "Cuprous iodide."
            },
            {
                "sectionName": "1271",
                "description": "L-Cysteine."
            },
            {
                "sectionName": "1272",
                "description": "L-Cysteine monohydrochloride."
            },
            {
                "sectionName": "1277",
                "description": "Dextrin."
            },
            {
                "sectionName": "1278",
                "description": "Diacetyl."
            },
            {
                "sectionName": "1282",
                "description": "Dill and its derivatives."
            },
            {
                "sectionName": "1287",
                "description": "Enzyme-modified fats."
            },
            {
                "sectionName": "1293",
                "description": "Ethyl alcohol."
            },
            {
                "sectionName": "1295",
                "description": "Ethyl formate."
            },
            {
                "sectionName": "1296",
                "description": "Ferric ammonium citrate."
            },
            {
                "sectionName": "1297",
                "description": "Ferric chloride."
            },
            {
                "sectionName": "1298",
                "description": "Ferric citrate."
            },
            {
                "sectionName": "1301",
                "description": "Ferric phosphate."
            },
            {
                "sectionName": "1304",
                "description": "Ferric pyrophosphate."
            },
            {
                "sectionName": "1307",
                "description": "Ferric sulfate."
            },
            {
                "sectionName": "1307a",
                "description": "Ferrous ascorbate."
            },
            {
                "sectionName": "1307b",
                "description": "Ferrous carbonate."
            },
            {
                "sectionName": "1307c",
                "description": "Ferrous citrate."
            },
            {
                "sectionName": "1307d",
                "description": "Ferrous fumarate."
            },
            {
                "sectionName": "1308",
                "description": "Ferrous gluconate."
            },
            {
                "sectionName": "1311",
                "description": "Ferrous lactate."
            },
            {
                "sectionName": "1315",
                "description": "Ferrous sulfate."
            },
            {
                "sectionName": "1316",
                "description": "Ficin."
            },
            {
                "sectionName": "1317",
                "description": "Garlic and its derivatives."
            },
            {
                "sectionName": "1318",
                "description": "Glucono delta-lactone."
            },
            {
                "sectionName": "1321",
                "description": "Corn gluten."
            },
            {
                "sectionName": "1322",
                "description": "Wheat gluten."
            },
            {
                "sectionName": "1323",
                "description": "Glyceryl monooleate."
            },
            {
                "sectionName": "1324",
                "description": "Glyceryl monostearate."
            },
            {
                "sectionName": "1328",
                "description": "Glyceryl behenate."
            },
            {
                "sectionName": "1329",
                "description": "Glyceryl palmitostearate."
            },
            {
                "sectionName": "1330",
                "description": "Acacia (gum arabic)."
            },
            {
                "sectionName": "1333",
                "description": "Gum ghatti."
            },
            {
                "sectionName": "1339",
                "description": "Guar gum."
            },
            {
                "sectionName": "1343",
                "description": "Locust (carob) bean gum."
            },
            {
                "sectionName": "1349",
                "description": "Karaya gum (sterculia gum)."
            },
            {
                "sectionName": "1351",
                "description": "Gum tragacanth."
            },
            {
                "sectionName": "1355",
                "description": "Helium."
            },
            {
                "sectionName": "1366",
                "description": "Hydrogen peroxide."
            },
            {
                "sectionName": "1370",
                "description": "Inositol."
            },
            {
                "sectionName": "1372",
                "description": "Insoluble glucose isomerase enzyme preparations."
            },
            {
                "sectionName": "1375",
                "description": "Iron, elemental."
            },
            {
                "sectionName": "1386",
                "description": "Isopropyl citrate."
            },
            {
                "sectionName": "1387",
                "description": "Lactase enzyme preparation from Candida pseudotropicalis."
            },
            {
                "sectionName": "1388",
                "description": "Lactase enzyme preparation from Kluyveromyces lactis."
            },
            {
                "sectionName": "1400",
                "description": "Lecithin."
            },
            {
                "sectionName": "1408",
                "description": "Licorice and licorice derivatives."
            },
            {
                "sectionName": "1409",
                "description": "Ground limestone."
            },
            {
                "sectionName": "1415",
                "description": "Animal lipase."
            },
            {
                "sectionName": "1420",
                "description": "Lipase enzyme preparation derived from Rhizopus niveus."
            },
            {
                "sectionName": "1425",
                "description": "Magnesium carbonate."
            },
            {
                "sectionName": "1426",
                "description": "Magnesium chloride."
            },
            {
                "sectionName": "1428",
                "description": "Magnesium hydroxide."
            },
            {
                "sectionName": "1431",
                "description": "Magnesium oxide."
            },
            {
                "sectionName": "1434",
                "description": "Magnesium phosphate."
            },
            {
                "sectionName": "1440",
                "description": "Magnesium stearate."
            },
            {
                "sectionName": "1443",
                "description": "Magnesium sulfate."
            },
            {
                "sectionName": "1443a",
                "description": "Malt."
            },
            {
                "sectionName": "1444",
                "description": "Maltodextrin."
            },
            {
                "sectionName": "1445",
                "description": "Malt syrup (malt extract)."
            },
            {
                "sectionName": "1446",
                "description": "Manganese chloride."
            },
            {
                "sectionName": "1449",
                "description": "Manganese citrate."
            },
            {
                "sectionName": "1452",
                "description": "Manganese gluconate."
            },
            {
                "sectionName": "1461",
                "description": "Manganese sulfate."
            },
            {
                "sectionName": "1472",
                "description": "Menhaden oil."
            },
            {
                "sectionName": "1490",
                "description": "Methylparaben."
            },
            {
                "sectionName": "1498",
                "description": "Microparticulated protein product."
            },
            {
                "sectionName": "1505",
                "description": "Mono- and diglycerides."
            },
            {
                "sectionName": "1521",
                "description": "Monosodium phosphate derivatives of mono- and diglycerides."
            },
            {
                "sectionName": "1530",
                "description": "Niacin."
            },
            {
                "sectionName": "1535",
                "description": "Niacinamide."
            },
            {
                "sectionName": "1537",
                "description": "Nickel."
            },
            {
                "sectionName": "1538",
                "description": "Nisin preparation."
            },
            {
                "sectionName": "1540",
                "description": "Nitrogen."
            },
            {
                "sectionName": "1545",
                "description": "Nitrous oxide."
            },
            {
                "sectionName": "1553",
                "description": "Peptones."
            },
            {
                "sectionName": "1555",
                "description": "Rapeseed oil."
            },
            {
                "sectionName": "1560",
                "description": "Ox bile extract."
            },
            {
                "sectionName": "1563",
                "description": "Ozone."
            },
            {
                "sectionName": "1583",
                "description": "Pancreatin."
            },
            {
                "sectionName": "1585",
                "description": "Papain."
            },
            {
                "sectionName": "1588",
                "description": "Pectins."
            },
            {
                "sectionName": "1595",
                "description": "Pepsin."
            },
            {
                "sectionName": "1610",
                "description": "Potassium alginate."
            },
            {
                "sectionName": "1613",
                "description": "Potassium bicarbonate."
            },
            {
                "sectionName": "1619",
                "description": "Potassium carbonate."
            },
            {
                "sectionName": "1622",
                "description": "Potassium chloride."
            },
            {
                "sectionName": "1625",
                "description": "Potassium citrate."
            },
            {
                "sectionName": "1631",
                "description": "Potassium hydroxide."
            },
            {
                "sectionName": "1634",
                "description": "Potassium iodide."
            },
            {
                "sectionName": "1635",
                "description": "Potassium iodate."
            },
            {
                "sectionName": "1639",
                "description": "Potassium lactate."
            },
            {
                "sectionName": "1643",
                "description": "Potassium sulfate."
            },
            {
                "sectionName": "1655",
                "description": "Propane."
            },
            {
                "sectionName": "1660",
                "description": "Propyl gallate."
            },
            {
                "sectionName": "1666",
                "description": "Propylene glycol."
            },
            {
                "sectionName": "1670",
                "description": "Propylparaben."
            },
            {
                "sectionName": "1676",
                "description": "Pyridoxine hydrochloride."
            },
            {
                "sectionName": "1685",
                "description": "Rennet (animal-derived) and chymosin preparation (fermentation-derived)."
            },
            {
                "sectionName": "1695",
                "description": "Riboflavin."
            },
            {
                "sectionName": "1697",
                "description": "Riboflavin-5'-phosphate (sodium)."
            },
            {
                "sectionName": "1698",
                "description": "Rue."
            },
            {
                "sectionName": "1699",
                "description": "Oil of rue."
            },
            {
                "sectionName": "1702",
                "description": "Sheanut oil."
            },
            {
                "sectionName": "1721",
                "description": "Sodium acetate."
            },
            {
                "sectionName": "1724",
                "description": "Sodium alginate."
            },
            {
                "sectionName": "1733",
                "description": "Sodium benzoate."
            },
            {
                "sectionName": "1736",
                "description": "Sodium bicarbonate."
            },
            {
                "sectionName": "1742",
                "description": "Sodium carbonate."
            },
            {
                "sectionName": "1751",
                "description": "Sodium citrate."
            },
            {
                "sectionName": "1754",
                "description": "Sodium diacetate."
            },
            {
                "sectionName": "1763",
                "description": "Sodium hydroxide."
            },
            {
                "sectionName": "1764",
                "description": "Sodium hypophosphite."
            },
            {
                "sectionName": "1768",
                "description": "Sodium lactate."
            },
            {
                "sectionName": "1769a",
                "description": "Sodium metasilicate."
            },
            {
                "sectionName": "1784",
                "description": "Sodium propionate."
            },
            {
                "sectionName": "1792",
                "description": "Sodium sesquicarbonate."
            },
            {
                "sectionName": "1801",
                "description": "Sodium tartrate."
            },
            {
                "sectionName": "1804",
                "description": "Sodium potassium tartrate."
            },
            {
                "sectionName": "1807",
                "description": "Sodium thiosulfate."
            },
            {
                "sectionName": "1835",
                "description": "Sorbitol."
            },
            {
                "sectionName": "1845",
                "description": "Stannous chloride (anhydrous and dihydrated)."
            },
            {
                "sectionName": "1848",
                "description": "Starter distillate."
            },
            {
                "sectionName": "1851",
                "description": "Stearyl citrate."
            },
            {
                "sectionName": "1854",
                "description": "Sucrose."
            },
            {
                "sectionName": "1857",
                "description": "Corn sugar."
            },
            {
                "sectionName": "1859",
                "description": "Invert sugar."
            },
            {
                "sectionName": "1865",
                "description": "Corn syrup."
            },
            {
                "sectionName": "1866",
                "description": "High fructose corn syrup."
            },
            {
                "sectionName": "1875",
                "description": "Thiamine hydrochloride."
            },
            {
                "sectionName": "1878",
                "description": "Thiamine mononitrate."
            },
            {
                "sectionName": "1890",
                "description": "a-Tocopherols."
            },
            {
                "sectionName": "1901",
                "description": "Triacetin."
            },
            {
                "sectionName": "1903",
                "description": "Tributyrin."
            },
            {
                "sectionName": "1911",
                "description": "Triethyl citrate."
            },
            {
                "sectionName": "1914",
                "description": "Trypsin."
            },
            {
                "sectionName": "1923",
                "description": "Urea."
            },
            {
                "sectionName": "1924",
                "description": "Urease enzyme preparation from Lactobacillus fermentum."
            },
            {
                "sectionName": "1930",
                "description": "Vitamin A."
            },
            {
                "sectionName": "1945",
                "description": "Vitamin B12."
            },
            {
                "sectionName": "1950",
                "description": "Vitamin D."
            },
            {
                "sectionName": "1973",
                "description": "Beeswax (yellow and white)."
            },
            {
                "sectionName": "1976",
                "description": "Candelilla wax."
            },
            {
                "sectionName": "1978",
                "description": "Carnauba wax."
            },
            {
                "sectionName": "1979",
                "description": "Whey."
            },
            {
                "sectionName": "1979a",
                "description": "Reduced lactose whey."
            },
            {
                "sectionName": "1979b",
                "description": "Reduced minerals whey."
            },
            {
                "sectionName": "1979c",
                "description": "Whey protein concentrate."
            },
            {
                "sectionName": "1983",
                "description": "Bakers yeast extract."
            },
            {
                "sectionName": "1984",
                "description": "Zein."
            },
            {
                "sectionName": "1985",
                "description": "Aminopeptidase enzyme preparation derived from lactococcus lactis."
            }
        ]
    },
    {
        "partNumber": 186,
        "sections": [
            {
                "sectionName": "1",
                "description": "Substances added indirectly to human food affirmed as generally recognized as safe (GRAS).  Please list all GRAS substances along with any FDA GRAS letters or company justifications"
            },
            {
                "sectionName": "1093",
                "description": "Sulfamic acid."
            },
            {
                "sectionName": "1256",
                "description": "Clay (kaolin)."
            },
            {
                "sectionName": "1275",
                "description": "Dextrans."
            },
            {
                "sectionName": "1300",
                "description": "Ferric oxide."
            },
            {
                "sectionName": "1316",
                "description": "Formic acid."
            },
            {
                "sectionName": "1374",
                "description": "Iron oxides."
            },
            {
                "sectionName": "1551",
                "description": "Hydrogenated fish oil."
            },
            {
                "sectionName": "1555",
                "description": "Japan wax."
            },
            {
                "sectionName": "1557",
                "description": "Tall oil."
            },
            {
                "sectionName": "1673",
                "description": "Pulp."
            },
            {
                "sectionName": "1750",
                "description": "Sodium chlorite."
            },
            {
                "sectionName": "1756",
                "description": "Sodium formate."
            },
            {
                "sectionName": "1770",
                "description": "Sodium oleate."
            },
            {
                "sectionName": "1771",
                "description": "Sodium palmitate."
            },
            {
                "sectionName": "1797",
                "description": "Sodium sulfate."
            },
            {
                "sectionName": "1839",
                "description": "Sorbose."
            }
        ]
    }
];

export default fdaCitationData;